import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import DataTable from "../../components/Table/Table";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/pro-light-svg-icons/faTrash';
import { ConfirmAction } from '../../components/Table/NewTable';
import { deleteEgressGateway, getEgressGateways } from '../../actions/actionEgressProvider';
import { notifyFailure, notifySuccess } from '../../components/Form/Form';
import LoadingSpinner from '../../components/LoadingSpinner';

export default function EgressGateway (props) {

    const { t } = useTranslation('common');
    const dispatch = useDispatch()
    const [modal, setModal] = useState(false)
    const [gateway, setGateway] = useState(null)
    const [gateways, setGateways] = useState(null)
    const [actions, setActions] = useState(null)
    const [onAdd, setOnAdd] = useState(null)
    const [isManaged, setIsManaged] = useState(null)
    const [currentEgressProvider, setCurrentEgressProvider] = useState(null)
    const egressGateways = useSelector(state => state.egress_provider.egress_gateways) || null
    const egressGatewayLoading = useSelector(state => state.egress_provider.egressGatewayLoading) || null
    const currentEgressProviderId = useSelector(state => state.egress_provider.currentProvider) || null
    const egressProviders = useSelector(state => state.egress_provider.egress_providers) || null

    useEffect(() => {
        dispatch(getGateways())
    }, []);

    useEffect(() => {
        if (egressGateways !== null) {
            setGateways(egressGateways.filter(gateway => gateway.egress_provider_id === props.egressProviderId))
        }
    }, [egressGateways]);

    useEffect(() => {
        if (egressProviders) {
            setCurrentEgressProvider(egressProviders.find(provider => provider.egress_provider_id === currentEgressProviderId))
        }
    }, [currentEgressProviderId, egressProviders])

    useEffect(() => {
        if (isManaged) {
            setActions(
                [
                    { id: "edit", icon: "fa-pencil", description: t('buttons.Edit') },
                ]
            )
        } else {
            setActions(
                [
                    { id: "edit", icon: "fa-pencil", description: t('buttons.Edit') },
                    { id: "delete", icon: "fa-trash", description: t('buttons.Delete') } 
                ]
            )
        }
    }, [isManaged])

    useEffect(() => {
        if (isManaged) {
            setOnAdd(null)
        } else {
            setOnAdd({
                name: t('buttons.Add'),
                action: '/update_egress_provider/' + props.egressProviderId + '/create_egress_gateway'
            })
        }
    }, [isManaged])

    useEffect(() => {
        if (currentEgressProvider && currentEgressProvider.is_managed) {
            setIsManaged(true)
        } else {
            setIsManaged(false)
        }
    }, [currentEgressProvider])

    const getGateways = () => {
        return getEgressGateways({
            egress_provider_id: props.egressProviderId
        })
    }

    const deleteEgressGatewayAction = async (setGateway = false) => {
        const egress_gateway_id = setGateway || gateway
        let data = { egress_gateway_id }
        try {
            const { response: { error_message: errorMessage } } = await dispatch(deleteEgressGateway(data));
            notifySuccess({ errorMessage, type: 'delete' })
            if (!setGateway) {
                dispatch(getGateways())
            }
            setModal(false)
        } catch(error) {
            notifyFailure({ error, type: 'delete' })
            setModal(false)
        }
    }
    
    const tableColumns = [
        {
            type: "text",
            name: t('egress_provider.name'),
            accessor: "name",
        },
        {
            type: "text",
            name: t('egress_provider.country'),
            accessor: "country",
        },
        {
            type: "flag",
            name: t('egress_provider.enabled'),
            accessor: "enabled",
        },
        {
            type: "text",
            name: t('egress_provider.city'),
            accessor: "city",
            showByDefault: false,
        },
        {
            type: "number",
            name: t('egress_provider.active-connections'),
            accessor: "active_connections",
        },
        {
            type: "number",
            name: t('egress_provider.egress-gateway-id'),
            accessor: "egress_gateway_id",
            showByDefault: false
        },
    ];

    const onAction = async (action, item) => {
        switch (action) {
            case "edit":
                props.history.push(`/update_egress_provider/${props.egressProviderId}/update_egress_gateway/${item.egress_gateway_id}`);
                break;

            case "delete":
                setGateway(item.egress_gateway_id)
                setModal(true)
                break;
            case "deleteMulti":
                const promises = []
                item.forEach(id => {
                    const promise = deleteEgressGatewayAction(id)
                    promises.push(promise)
                })
                await Promise.all(promises)
                dispatch(getGateways())
                break;
        }
    }



    if (egressGatewayLoading){
        return (<div> <LoadingSpinner /></div>);
    }

    return (
        <React.Fragment>
            <DataTable
                id="egress_gateway"
                data={gateways}
                columns={tableColumns}
                actions={actions}
                onAction={onAction}
                mainId="egress_gateway_id"
                add={onAdd}
            />

            <ConfirmAction
                confirmationDetails={{
                    action: null,
                    details: {
                        title: t('egress_provider.notify-delete-title'),
                        text: t('egress_provider.are-you-sure-you-want-to-delet-gateway'),
                        iconBg: 'tw-bg-pink-700 tw-text-white',
                        icon: <FontAwesomeIcon icon={faTrash} />,
                        confirmBg: 'tw-bg-pink-700',
                        confirmText: t('buttons.Delete'),

                    }
                }}
                open={modal}
                externalClose={true}
                setOpen={setModal}
                onAction={deleteEgressGatewayAction}
            />
        </React.Fragment>
    );
}
